import React from 'react';
import styled from 'styled-components';
import { useFeatureFlag } from '../../../_hooks/useFeatureFlag';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { PageWrapper } from '../../../CommonComponents/PageWrapper/PageWrapper';
import { Feature } from '../../../CommonSelectors/CommonArea.types';
import { MobileHeader } from '../../components/MobileHeader/MobileHeader';
import { PeriodSelector } from '../../components/PeriodSelector/PeriodSelector';
import { TransactionsTab } from './Components/TransactionsTab/TransactionTab';

export const MobileWrapper = styled(Box)({
  marginBottom: 32,
});

const getTabMap = (showActivityDetails: boolean) => {
  return {
    name: showActivityDetails ? 'Activity' : 'Transactions',
    component: TransactionsTab,
  };
};

interface Props {
  managedAccountId: string;
  selectedItemName: string;
  updatedAt: string;
}

const Transactions = ({ managedAccountId, selectedItemName, updatedAt }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const showActivityDetails = useFeatureFlag(Feature.ActivityDetails);

  const { component: Component } = getTabMap(showActivityDetails);
  const Wrapper = isEmbeddedMobile ? MobileWrapper : PageWrapper;

  return (
    <Wrapper>
      {isEmbeddedMobile && (
        <Box mx="16" mb="12">
          <MobileHeader label={selectedItemName} subLabel={`Last updated: ${updatedAt}`} />
        </Box>
      )}

      {isEmbeddedMobile && (
        <Box px="16" mt="12">
          <PeriodSelector isVerticalLayout={isEmbeddedMobile} />
        </Box>
      )}

      <Component managedAccountId={managedAccountId} />
    </Wrapper>
  );
};

export default Transactions;
